// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.00391 10.0041V8.00015H5.00391V8.00406H5V10.0041H7.00391Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 5.58594L6 1.58594L2 5.58594V22.0002L11.5 22V15H18.5V22H22V9.99561H20.9751C20.7275 7.49954 18.6607 5.48522 16 5.07605V3.5H14V5.07605C12.3332 5.33238 10.8994 6.21866 10 7.45869V5.58594ZM7.99609 20.0002H4V6.41437L6 4.41436L8 6.41436L7.99609 20.0002Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.5 17V22H16.5V17H13.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mosque-1-filled')
export default class Mosque1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mosque-1-filled',
    }
  }
}
